import { render, staticRenderFns } from "./game-list.vue?vue&type=template&id=3cc5648a&scoped=true&"
import script from "./game-list.vue?vue&type=script&lang=js&"
export * from "./game-list.vue?vue&type=script&lang=js&"
import style0 from "./game-list.vue?vue&type=style&index=0&id=3cc5648a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5648a",
  null
  
)

export default component.exports